import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.reduce";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';

var messageImg = require('@/assets/image/message.png');

export default {
  data: function data() {
    return {
      messageImg: messageImg
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('d2admin', {
    logLength: 'message/length'
  })), {}, {
    tooltipContent: function tooltipContent() {
      return this.logLength === 0 ? '没有消息' : "".concat(this.logLength, " \u6761\u6D88\u606F").concat(this.logLengthError > 0 ? '' : '');
    },
    token: function token() {
      var token = YL.cookies.get(process.env.VUE_APP_LOGIN_TOKEN) || '';
      return token;
    }
  }),
  mounted: function mounted() {
    this.token && this.dataBind();
  },
  methods: {
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.messages({
                  pageSize: 1000 * 1000
                });

              case 2:
                res = _context.sent;
                n = res.records.reduce(function (l, i) {
                  return !i.messageRead ? l + 1 : l;
                }, 0);

                _this.$store.dispatch('d2admin/message/asyncMessage', n);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleClick: function handleClick() {
      this.$router.push({
        name: 'news'
      });
    }
  }
};